import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AlertService } from '../alert';


@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.html',
  styleUrls: ['./alert.css'],
})
export class AlertComponent implements OnInit {
  alert: any;

  constructor(
    private alertService: AlertService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.alertService.alert$.subscribe((alert) => {
      this.alert = alert;

      if (alert) {
        this.cdr.detectChanges();
        setTimeout(() => {
          this.alert = null;
          this.cdr.detectChanges();
        }, 3000);
      }
    });
  }
}
